import React from 'react';
import { FaBars } from 'react-icons/fa';

const Header = ({ isMenuOpen, onMenuClick, setIsHowToPlayOpen }) => {
  return (
    <header className="game-header">
      <div className="header-content">
        <h1 className="brand-name">🍿 MovieQuest 🎬</h1>
        <div className="icon-container">
          <button 
            className="how-to-play-button" 
            onClick={() => setIsHowToPlayOpen(true)}
          >
            How To Play
          </button>
          <button 
            className={`menu-button ${isMenuOpen ? 'active' : ''}`} 
            onClick={onMenuClick}
            aria-label="Toggle menu"
            aria-expanded={isMenuOpen}
          >
            <FaBars className="menu-icon" />
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header; 